


















import { mapState } from "vuex";
import GlobalError from "@/components/basic/GlobalError.vue";
import Logo from "@/components/Logo.vue";
import ProgressBar from "@/components/ProgressBar.vue";
import Vue from "vue";
import Loader from "@/components/basic/Loader.vue";
import { SET_STEP } from "@/constants/mutation-types";
import {UtilityHelper} from "@/helpers/UtilityHelper";
import { MetaData } from './constants/meta-data';
import i18n from "@/i18n";
import SidePanel from "./components/basic/SidePanel.vue";
import Disclaimer from "./components/basic/Disclaimer.vue";

export default Vue.extend({
  name: "app",
  metaInfo() {
    return {
      title: MetaData[i18n.locale]['title'],
      meta: [
        { name: 'title', content:  MetaData[i18n.locale]['metaTitle']},
        { name: 'description', content:  MetaData[i18n.locale]['metaDescription']},
        { property: 'og:title', content: MetaData[i18n.locale]['metaTitle']},
        { property: 'og:site_name', content: MetaData[i18n.locale]['title']},
        {property: 'og:type', content: 'website'},
        {property: 'og:url', content: MetaData[i18n.locale]['ogUrl']},
        {property: 'og:image', content: MetaData[i18n.locale]['ogImage']},
        {name: 'robots', content: 'index,follow'}
      ]
    }
  },
  computed: {
    UtilityHelper() {
      return UtilityHelper
    },
    ...mapState({
      isOpenModal: (state: any) => state.isDarkBackground,
      isGbg: (state: any) => state.isGbg,
      isUploadDocumentStep: (state: any) => state.isUploadDocumentStep,
      showLongDisclaimer: (state: any) => state.showLongDisclaimer,
    }),
  },
  mounted() {
    document.addEventListener("drop", (evt: DragEvent) => this.preventDefault(evt));
    document.addEventListener("dragover", (evt: DragEvent) => this.preventDefault(evt));
    window.addEventListener("beforeunload", (evt: BeforeUnloadEvent) => this.removeItemFromLocalStorage(evt));
    window.addEventListener("popstate", this.setAppropriateCurrentStep);

    function setAutoDarkClass() {
      // We can also use JavaScript to generate the detection element.
      const detectionDiv = document.createElement('div');
      //@ts-ignore
      detectionDiv.style.display = 'none';
      //@ts-ignore
      detectionDiv.style.backgroundColor = 'canvas';
      //@ts-ignore
      detectionDiv.style.colorScheme = 'light';
      document.body.appendChild(detectionDiv);
      // If the computed style is not white then the page is in Auto Dark Theme.
      const isAutoDark = getComputedStyle(detectionDiv).backgroundColor != 'rgb(255, 255, 255)';

      // remove the detection element from the DOM.
      document.body.removeChild(detectionDiv);

      // Set the marker class on the body if in Auto Dark Theme.
      if (isAutoDark) {
        document.body.classList.add('auto-dark-theme');
      }
    }
    document.addEventListener("DOMContentLoaded", setAutoDarkClass);
  },
  methods: {
    preventDefault(evt: DragEvent): void {
      if (
        (evt.target as HTMLElement).localName === "body" ||
        !(evt.target as HTMLElement).closest(".container-file-component")
      ) {
        evt.preventDefault();
      }
    },

    removeItemFromLocalStorage(evt: BeforeUnloadEvent): undefined {
      if (window.localStorage.getItem("isReturning")) {
        window.localStorage.removeItem("isReturning");
      }
      return undefined;
    },
    setAppropriateCurrentStep(): void {
      const routes = (this as any).$router.options.routes;
      const splitPathName = window.location.pathname.split("/");

      let searchedRouteName = null as null | string;

      if (Array.isArray(splitPathName) && splitPathName.length) {
        const currentRoutePath = "/" + splitPathName[splitPathName.length - 1];

        for (const key in routes) {
          if (routes.hasOwnProperty(key) && routes[key].path === currentRoutePath) {
            searchedRouteName = routes[key].name;
            break;
          }
        }
      }
      if (searchedRouteName && this.$store.state.currentStep !== searchedRouteName) {
        this.$store.commit(SET_STEP, searchedRouteName);
      }
    },
  },
  components: {
    GlobalError,
    Loader,
    ProgressBar,
    Logo,
    SidePanel,
    Disclaimer
  },
  data() {
    return {
      TRANSLATION_KEY: "App",
    };
  },
});
